export const MESSAGE_TYPES = {
	LOGOUT: 'logout',
};
